import React from "react";
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Button
} from "@carbon/react";

const TrimbleCarbonTable = ({ rows, headers, fetchData }) => {

  return (
<DataTable
  rows={rows}
  headers={headers}
  render={({ rows, headers, getHeaderProps, getRowProps }) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => {
              const { key: _unusedKey, ...headerProps } = getHeaderProps({ header });
              return (
                <TableHeader key={header.key} {...headerProps}>
                  {header.header}
                </TableHeader>
              );
            })}
            <TableHeader>Ver Informe</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => {
            const { key: _unusedKey, ...rowProps } = getRowProps({ row });

            return (
              <React.Fragment key={row.id}>
                <TableRow {...rowProps}>
                  {row.cells.map((cell) => (
                    <TableCell key={cell.id}>{cell.value}</TableCell>
                  ))}
                  <TableCell key="action">
                    <Button
                      size="sm"
                      onClick={() =>
                        fetchData(
                          row.cells.find(
                            (cell) => cell.info.header === "alineacion_partition"
                          )?.value,
                          row.cells.find(
                            (cell) => cell.info.header === "date_partition"
                          )?.value
                        )
                      }
                    >
                      Ver Informe
                    </Button>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )}
/>

  );
};

export default TrimbleCarbonTable;
